import { cva } from '@/styled-system/css';

export const triggerButtonRecipe = cva({
  base: {
    alignItems: 'center',
    blockSize: 'icon.md',
    borderRadius: 'shape.ellipse',
    cursor: 'pointer',
    display: 'inline-flex',
    inlineSize: 'icon.md',
    justifyContent: 'center',

    color: {
      base: 'icon.action.hero.default',
      _hover: 'icon.action.hero.hover',
      _active: 'icon.action.hero.pressed',
    },

    _focusVisible: {
      boxShadow: 'focus',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
  },
});
